export default __webpack_public_path__ + "static/media/WomeninCleanEnergy.97ade18c.jpg";